import { render, staticRenderFns } from "./TotalPendingCaseTableModal.vue?vue&type=template&id=41f804ad"
import script from "./TotalPendingCaseTableModal.vue?vue&type=script&lang=js"
export * from "./TotalPendingCaseTableModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports